package gr.tech.meetinggenie.models.meeting

import kotlinx.serialization.Serializable

@Serializable
data class MeetingResponseDTO(
    val id: Int? = null,
    val meetingId: Int? = null,
    val userId: Int? = null,
    val userName: String? = null,
    val userEmail: String? = null,
    val userImageUrl: String? = null,
    val isPriority: Boolean = false,
    val formData: MeetingFormDataDTO = MeetingFormDataDTO(),
    val submitted: Boolean = false,
    val updatedAt: String? = null,
)
